import { StatusCodes } from "http-status-codes";
import request from "../request";
import { getUserToken } from "../../utils/getUserToken";
import { STATUS } from "../../constants";

const isDataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";

export const syncSpecialists = async () => {
  const token = await getUserToken();
  return await request.get(isDataFromPMS ? "/pms/admin/specialists/sync" : "/admin/specialists/sync", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchSpecialistsAvailableTime = async (specialistId, month) => {
  const token = await getUserToken();
  return await request.get(`/admin/specialists/available-time`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      specialistId,
      month,
    },
  });
};

export const deleteAvailableTime = async ({ specialistId, date }) => {
  try {
    const token = await getUserToken();
    const result = await request.delete("/admin/specialists/available-time", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { specialistId, date },
    });
    if (result.status === StatusCodes.NO_CONTENT) {
      return { successful: true, data: {} };
    }
    return { successful: false, message: "Internal Server Error" };
  } catch (error) {
    return { successful: false, message: `${error}` };
  }
};

export const updateSpecialist = async (newSpecialist, setSpecialistUpdateStatus) => {
  setSpecialistUpdateStatus(STATUS.LOADING);
  try {
    const token = await getUserToken();
    const result = await request.put("/admin/specialists/apt-length", newSpecialist, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (result.status === StatusCodes.NO_CONTENT) {
      setSpecialistUpdateStatus(STATUS.SUCCEED);
    }

    setSpecialistUpdateStatus(STATUS.FAILED);
  } catch (e) {
    console.error(`There has some errors during update specialist: ${e}`);
    setSpecialistUpdateStatus(STATUS.FAILED);
  }
};

export const createSpecialistAvailableTimeslots = async (specialistAvailableDate, setCreateStatus, isPrivate) => {
  const errorMessage = "There has some errors during create specialist available date, please try again.";
  setCreateStatus({
    status: STATUS.LOADING,
    message: null,
  });
  try {
    const token = await getUserToken();
    const result = await request.post(
      "/admin/specialists/available-time",
      { ...specialistAvailableDate, isPrivate },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (result.status === StatusCodes.CREATED) {
      setCreateStatus({
        status: STATUS.SUCCEED,
        message: null,
      });
      return;
    }

    setCreateStatus({
      status: STATUS.FAILED,
      message: errorMessage,
    });
  } catch (e) {
    console.error(`There has some errors during create specialist available date: ${e}`);
    setCreateStatus({
      status: STATUS.FAILED,
      message: errorMessage,
    });
  }
};
